/**
 * Intercepted fetch logic
 */

const CommonResponseHandler = (
    resolve: (response: any) => any,
    reject: (err: any) => any,
    response: Response
) => {
    // Get the contentType and determine the next steps
    const contentType = response.headers.get("content-type");
    if (contentType === "application/json") {
        if (response.ok) {
            response.json().then((r) => resolve(r));
        } else {
            response.json().then((r) => reject(r));
        }
    } else if (contentType === "text/plain") {
        if (response.ok) {
            response.text().then((r) => resolve(r));
        } else {
            response.text().then((r) => reject(r));
        }
    } else {
        if (response.ok) {
            resolve(response);
        } else {
            reject(response);
        }
    }
};

export const InterceptedFetch = (
    onUnauthorized: () => Promise<boolean>
): Function => {
    return (url, options, refreshToken = true): Promise<any> => {
        const opts = Object.assign(
            {
                cache: "no-cache",
                headers: {
                    "content-type": "application/json"
                },
                mode: "cors",
                referrer: "no-referrer",
                credentials: "include"
            },
            options
        );

        // If the body is a non-string, then assume it is to be stringified to JSON
        if (opts.body !== undefined && typeof opts.body !== "string") {
            opts.body = JSON.stringify(opts.body);
        }

        return new Promise((resolve, reject) => {
            const MakeRequest = async () => {
                try {
                    const response = await fetch(url, opts);
                    if (response.status === 401) {
                        if (await onUnauthorized()) {
                            // Try again
                            MakeRequest();
                        }
                        return;
                    }
                    CommonResponseHandler(resolve, reject, response);
                } catch (err) {
                    reject(err);
                }
            };
            MakeRequest();
        });
    };
};
